var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Arrow Right"),React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"none","strokeWidth":"1","key":1},React.createElement("g",{"fill":"#27316D","transform":"translate(-285.000000, -656.000000)"},React.createElement("g",{"transform":"translate(135.000000, 530.000000)"},React.createElement("g",{"transform":"translate(0.000000, 118.000000)"},React.createElement("g",{"transform":"translate(150.000000, 8.000000)"},React.createElement("polygon",{"points":"12.414 8 12.414 4.993 0 4.993 0 3.039 12.414 3.039 12.414 0 17.407 4.004"}))))))]);
}

ArrowRight.defaultProps = {"width":"18","height":"8","version":"1.1","viewBox":"0 0 18 8"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
